import { useEffect } from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Container, Image, Stack, Text, Title } from '@mantine/core';
import { NavigationProgress, nprogress } from '@mantine/nprogress';
import { NothingFoundBackground } from '@/components/not-found';
import DashboardLayout from '@/layouts/dashboard-layout/dashboard-layout';
import { DevToolsLayout } from '@/layouts/dev-tools-layout';
import { usePWA } from '@/pwa';
import { useAppStore } from '@/stores/app-store';
import { useAuthStore } from '@/stores/auth-store';
import { isChrome } from '@/utils';

export const Route = createRootRoute({
  component: () => {
    const loading = useAppStore((state) => state.pageLoading);

    useEffect(() => {
      if (loading) {
        nprogress.start();
      } else {
        nprogress.complete();
      }
    }, [loading]); // Runs when `count` changes

    const { updateServiceWorker } = usePWA();

    useEffect(() => {
      const onFocus = () => {
        if (document.visibilityState === 'visible') {
          updateServiceWorker(true);
        }
      };

      window.addEventListener('focus', onFocus);
      document.addEventListener('visibilitychange', onFocus);

      return () => {
        window.removeEventListener('focus', onFocus);
        document.removeEventListener('visibilitychange', onFocus);
      };
    }, [updateServiceWorker]);

    if (!isChrome()) {
      return (
        <Container display="flex" h="100vh" w="100vw" fluid p="xl">
          <Stack align="center" justify="center" gap={0} w="100%">
            <Image alt="chrome" src="/chrome.svg" h={400} w="auto" />
            <Title fz={32} fw={700} ta="center">
              Mohon gunakan Google Chrome
            </Title>
            <Text ta="center">
              Browser selain <b>Google Chrome</b> tidak kompatibel dengan sistem ini
            </Text>
          </Stack>
        </Container>
      );
    }

    return (
      <>
        <NavigationProgress />
        <Outlet />
        <DevToolsLayout />
      </>
    );
  },

  notFoundComponent: () => {
    const { isAuthenticated } = useAuthStore.getState();

    if (isAuthenticated()) {
      return (
        <DashboardLayout>
          <NothingFoundBackground />
        </DashboardLayout>
      );
    }
    return <NothingFoundBackground />;
  },
});
